<template>
    <div>
        <v-card>
            <v-card-text>
                <div class="flex-container pt-5">

                    <div class="image-container" style="margin-right: 20px;">
                        <template v-if="$props.selectedUser.userImage">
                        <img :src="$props.selectedUser.userImage" v-if="$props.selectedUser.userImage" />
                        </template>
                        <v-icon class="no-image" v-if="!$props.selectedUser.userImage">mdi-account</v-icon>
                    </div>

                    <div style="flex-grow: 1;">
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Username" color="#c42111" v-model="$props.selectedUser.user_username" readonly />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Full Name" color="#c42111" v-model="$props.selectedUser.user_fullname" readonly />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-badge bordered :color="$props.selectedUser.user_data.email_verified ? '#4CAF50' : '#FB8C00'" :icon="$props.selectedUser.user_data.email_verified ? 'mdi-check' : 'mdi-exclamation'" overlap style="width: 100%" offset-x="20" v-if="$props.selectedUser.user_page_email">
                                    <v-text-field label="E-mail" color="#c42111" v-model="$props.selectedUser.user_page_email" readonly />
                                </v-badge>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-badge bordered :color="$props.selectedUser.user_data.email_verified ? '#4CAF50' : '#FB8C00'" :icon="$props.selectedUser.user_data.sms_verified ? 'mdi-check' : 'mdi-exclamation'" overlap style="width: 100%" offset-x="20" v-if="$props.selectedUser.user_page_smpp">
                                    <v-text-field label="Phone" color="#c42111" v-model="$props.selectedUser.user_page_smpp" readonly />
                                </v-badge>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-text-field label="Manager" color="#c42111" v-model="selectedUserManager" readonly />
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-switch style="display: inline-block" class="mr-3" label="Account Locked" v-model="$props.selectedUser.user_locked" color="#c42111" readonly></v-switch>
                                <v-switch style="display: inline-block" label="Is Admin" v-model="$props.selectedUser.user_data.is_customer_admin" color="#c42111" readonly></v-switch>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <!-- <v-btn color="#c42111">Edit User</v-btn> -->
                                <v-btn color="#c42111" @click="showAllPermissions = true" :disabled="$props.selectedUser.user_data.is_customer_admin">All Permissions</v-btn>
                            </v-col>
                        </v-row>
                    </div>

                </div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn text @click="$emit('close')">Close</v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog v-model="showAllPermissions" max-width="80%" width="1200px" persistent v-if="showAllPermissions" @keydown="(k) => {k.key == 'Escape' ? showAllPermissions = false : null}">
            <all-permissions :userPermissions="[]" :userId="$props.selectedUser.user_id"  @close="showAllPermissions = false" v-if="showAllPermissions"></all-permissions>
        </v-dialog>
    </div>
</template>

<script>
import AllPermissions from "@/components/Users/AllPermissions";
export default {
    name: 'UserInfo',
    props: ['selectedUser'],
    components: {
        AllPermissions
    },
    data: () => ({
        showAllPermissions: false

    }),

    computed: {
        selectedUserManager() {
            if(this.$props.selectedUser && this.$props.selectedUser.user_manager && this.$props.selectedUser.user_manager != -1) {
                return this.$store.state.batchConfig.users.find(u => u.user_id == this.$props.selectedUser.user_manager).user_fullname;
            }
            return "[none]";
        }
    },

    methods: {

    },

    mounted() {

    }

  
};
</script>

<style scoped>

    .flex-container {
        flex-grow: 1;
        display: flex;
        width: 100%;
    }

    .image-container {
        height: 260px;
        width: 260px;
        max-height: 260px;
        max-width: 260px;
        border: black solid 1px;
        position: relative;
    }

    .image-container img {
        max-height: 260px;
        max-width: 260px;
    }

    .image-container .no-image {
        width: 100%;
        height: 100%;
        font-size: 300px;
    }

</style>
